import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { catchError, forkJoin, of, take } from 'rxjs';
import { MatDialogComponent } from 'src/app/mat-dialog/mat-dialog.component';
import { AppService } from 'src/app/services/app.service';
import { Approvalstatus, Client, StyleSettingsDealerImage, StyleSettingsResponse, StyleSettingTitles } from 'src/app/services/client.service';
import { DownloadPdfService } from 'src/app/services/download-pdf.service';
import { TourGuideDialogComponent } from 'src/app/tour-guide-dialog/tour-guide-dialog.component';
import { ButtonModule, IconModule, StructuredListModule, TilesModule } from 'carbon-components-angular';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { ProformaInvoiceAuthComponent } from '../proforma-invoice-auth/proforma-invoice-auth.component';
import { TickSnackbarComponent } from 'src/app/tick-snackbar/tick-snackbar.component';
import { MatSnackBarComponent } from 'src/app/mat-snack-bar/mat-snack-bar.component';
import { FeatureFlagService } from 'src/app/services/feature-flag.service';


@Component({
  selector: 'app-proforma-invoice-home',
  standalone: true,
  imports: [
    MatExpansionModule,
    MatIconModule,
    MatDialogModule,
    MatCardModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    CommonModule,
    IconModule,
    ButtonModule,
    TilesModule,
    NgxExtendedPdfViewerModule,
    MatTabsModule,
    StructuredListModule,
    MatButtonModule,
    MatSnackBarModule,
    MatMenuModule,
    RouterModule,
    ProformaInvoiceAuthComponent
  ],
  templateUrl: './proforma-invoice-home.component.html',
  styleUrl: './proforma-invoice-home.component.scss'
})
export class ProformaInvoiceHomeComponent {
  authInvoieText: string = $localize`Authorize invoice`;
  authInvoieInfoText: string = $localize`Please check the invoice and give your approval.`;
  downloadpdf: string = $localize`Invoice PDF`;
  downloadpdfDescription: string = $localize`Download invoice PDF.`;
  downloadPdfMessage: string = $localize`Invoice downloaded successfully`;

  pdfBase64Data: string = '';
  isPDFDataAvailable: boolean = true;
  token: string = '';
  isLargeScreen: boolean = window.innerWidth > 900;
  isScreenSize: boolean = window.innerWidth > 900;
  apiResponse: any;
  isDownloading = false;
  downloadCompleted = false;
  dealerImageDetails: StyleSettingsDealerImage | undefined;
  siteSettings: StyleSettingsResponse | undefined;
  currentStepperPosition: number | undefined;
  @ViewChild('downloadPDFTour') downloadPDFTour!: ElementRef;
  @ViewChild('authInvoice') authInvoice!: ElementRef;
  totalSteps: number = 3;
  selectedLanguage: string = '';
  isAuthorized: boolean = false;
  downloadPdfreport: string = $localize`download Pdf`;
  isAllowed = true;

  constructor(public dialog: MatDialog, private readonly router: Router, private readonly route: ActivatedRoute, private readonly pdfService: DownloadPdfService, public appService: AppService, private readonly client: Client, @Inject(PLATFORM_ID) private platformId: Object,
    private snackBar: MatSnackBar,private featureFlagService: FeatureFlagService) { }

ngOnInit(): void {
  this.checkScreenSize();

  this.route.queryParams.subscribe(params => {
    this.token = params['token'];

    this.getProformaInvoiceReport(this.token);
    this.loadProformaInvoiceData();

    this.featureFlagService.getFeatures(this.token, 'Proforma-Invoice-Report')
      .then(allowed => {
        if (!allowed) {
          this.isAllowed = false; 
          const apiAdapterVersion = sessionStorage.getItem('apiAdapterVersion');
          let featureMessage = '';
          if (apiAdapterVersion && apiAdapterVersion >= '3.13') {
            featureMessage = `The feature "ProformaInvoice" is currently not enabled in MW Admin Portal - Feature Management. Please contact support for more information.`;
          }
          else {
            featureMessage = `This feature is not supported for your adapter version, please contact support for more information.`;
          }

          this.snackBar.openFromComponent(MatSnackBarComponent, {
            data: featureMessage,
            duration: 10000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
          });
        }
      })
      .catch(() => {
        this.isAllowed = false;
      });
  });
}


  openWelcomeDialog() {
    const localLang = localStorage.getItem('lang')
    if (localLang == null) {
      const dialogRef = this.dialog.open(MatDialogComponent, {
        data: {
          type: 'LanguageDialog',
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        this.welcomeDialog(this.apiResponse.customer.name);
      });
    } else {
      this.appService.setDefaultLanguage();
      this.welcomeDialog(this.apiResponse.customer.name);
    }

    if (this.isScreenSize == false) {
      this.appService.tourGuideStepPosition$.subscribe((position: number) => {
        if (position !== undefined) {
          this.currentStepperPosition = position
        }
        if (position > 0) {
          let targetElementRect
          const dialogConfig = new MatDialogConfig()
          if (position === 1) {
            this.appService.languaTourGuide('Proforma-Invoice');
          } else if (position === 2) {
            targetElementRect = this.downloadPDFTour.nativeElement.getBoundingClientRect();
            this.downloadPDFTour.nativeElement.classList.add('tour-dialog-indication');
            dialogConfig.data = {
              title: this.downloadpdf,
              desciption: this.downloadpdfDescription,
              stepCount: 2,
              totalSteps: this.totalSteps,
              position: targetElementRect
            }
            this.startProformaInvoiceTour(dialogConfig);
          } else if (position === 3) {
            targetElementRect = this.authInvoice.nativeElement.getBoundingClientRect();
            this.authInvoice.nativeElement.classList.add('tour-dialog-indication');
            dialogConfig.data = {
              title: this.authInvoieText,
              desciption: this.authInvoieInfoText,
              stepCount: 3,
              totalSteps: this.totalSteps,
              position: targetElementRect
            };
            this.startProformaInvoiceTour(dialogConfig);
          }
        }
      });
    }
  }

  @HostListener('window:resize', [])
  onResize() {
    this.checkScreenSize();
  }

  loadProformaInvoiceData() {
    if (!this.token) {
      return;
    }

    this.appService.healthCheckReportWithJobs$ = undefined;
    this.appService.companySetting$ = undefined;
    const storedLang = window.localStorage.getItem('lang');
    this.selectedLanguage = storedLang ?? 'en-US';
    forkJoin({
      healthCheckReport: this.client.proformaDetails(this.token, this.selectedLanguage),
      stylesettings: this.appService.getStyleSettings(this.token).pipe(
        catchError((error) => {
          const errorMessage = error instanceof Error ? error.message : String(error);
          this.appService.handleErrorMessage(errorMessage);
          return of(null);
        })
      )
    })
      .pipe(take(1))
      .subscribe({
        next: ({ healthCheckReport, stylesettings }) => {
          this.apiResponse = healthCheckReport[0];
          if (this.apiResponse?.approvalStatus == Approvalstatus.Accept) {
            this.isAuthorized = true;
          }
          this.siteSettings = stylesettings;
          this.dealerImageDetails = stylesettings?.dealerImage;
          this.appService.setResponseData(this.apiResponse);
          const tourGuide = sessionStorage.getItem('tourGuide');
          if (tourGuide !== 'true' && this.isAllowed) {
            this.openWelcomeDialog();
          }
        },
        error: (error) => {
          const errorMessage = error instanceof Error ? error.message : String(error);
          this.appService.handleErrorMessage(errorMessage);
        }
      });
  }

  welcomeDialog(customerName: string | undefined) {
    const title = this.siteSettings?.titles?.find((title: StyleSettingTitles) => {
      return title.page === 'ProformaReport' && title.type === 'Welcome' && title.content;
    });
    const Content = title?.content ? this.appService.convertToHtml(title.content) : null;
    if (this.isScreenSize == false) {
      const dialogRef = this.dialog.open(MatDialogComponent, {
        data: {
          type: 'ProformaInvoiceWelcomeDialog',
          customerName: customerName,
          content: Content
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        sessionStorage.setItem("tourGuide", "true")
        if (result) {
          this.appService.tourGuideStepPosition(1)
        }
      });
    } else {
      const dialogRef = this.dialog.open(MatDialogComponent, {
        data: {
          type: 'ProformaInvoiceWelcomeDialogInLargeScreen',
          customerName: customerName,
          content: Content
        },
      });
    }
  }

  startProformaInvoiceTour(dialogConfig: MatDialogConfig) {
    let screenInnerHeight;
    if (isPlatformBrowser(this.platformId)) {
      screenInnerHeight = window.innerHeight
    } else {
      screenInnerHeight = 0
    }
    if (screenInnerHeight > dialogConfig.data.position.bottom) {
      if (screenInnerHeight - dialogConfig.data.position.bottom > 200) {
        dialogConfig.position = {
          top: `${dialogConfig.data.position.bottom + 5}px`,
          left: `${dialogConfig.data.position.right - 270}px`,
        };
      }
      else {
        dialogConfig.position = {
          top: `${dialogConfig.data.position.bottom - 200}px`,
          left: `${dialogConfig.data.position.right - 270}px`,
        };
      }
    }
    else {
      window.scroll({
        top: dialogConfig.data.position.bottom,
        behavior: 'smooth'
      });
      dialogConfig.position = {
        top: `${(screenInnerHeight - dialogConfig.data.position.height) - 210}px`,
        left: `${dialogConfig.data.position.right - 270}px`,
      };
    }

    setTimeout(() => {
      const dialogRef = this.dialog.open(TourGuideDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        this.downloadPDFTour.nativeElement.classList.remove('tour-dialog-indication');
        this.authInvoice.nativeElement.classList.remove('tour-dialog-indication');
        this.appService.tourGuideStepPosition(result)
      });
    }, 200);
  }

  navigateToproformaInvoiceDetails() {
    if (this.isLargeScreen) {
      return;
    }
    else {
      this.appService.setResponseData(this.apiResponse);
      this.router.navigate(['/proforma-invoice-auth'], {
        queryParams: {
          ...this.route.snapshot.queryParams,
          filter: 'checked'
        }
      });
    }
  }

  downloadPdf() {
    if (this.pdfBase64Data) {
      if (!this.downloadCompleted) {
        this.isDownloading = true;
      }

      this.pdfService.downloadPdf(this.pdfBase64Data, 'Proforma-Invoice.pdf', 'application/pdf')
        .then(() => {
          if (!this.downloadCompleted) {
            setTimeout(() => {
              this.isDownloading = false;
              this.downloadCompleted = true;
              this.showPdfDownloadMessage();
              setTimeout(() => {
                this.downloadCompleted = false;
              }, 5000);

            }, 1000);
          }
        })
        .catch(() => {
          this.isDownloading = false;
        });
    } else {
      this.isPDFDataAvailable = false;
       this.snackBar.openFromComponent(MatSnackBarComponent, {
      data: "Report setup is missing for Proforma Invoice in DMS.",
      duration: 5000,
      });
    }
  }

  showPdfDownloadMessage(): void {
    this.snackBar.openFromComponent(TickSnackbarComponent, {
      data: this.downloadPdfMessage,
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['custom-snackbar']
    });
  }

  getProformaInvoiceReport(token: string) {
    this.appService.getProformaReport(token)?.subscribe((data: string) => {
      this.pdfBase64Data = data;
      this.appService.setPdfBase64Data(this.pdfBase64Data);
      this.isPDFDataAvailable = true;
    })
  }

  updateApprovalStatus(approvalStatus: boolean) {
    this.isAuthorized = approvalStatus;
  }

  checkScreenSize() {
    this.isLargeScreen = window.innerWidth > 900;
  }
}
